import { render, staticRenderFns } from "./MyAddresses.vue?vue&type=template&id=75db0f52&scoped=true"
import script from "./MyAddresses.vue?vue&type=script&lang=js"
export * from "./MyAddresses.vue?vue&type=script&lang=js"
import style0 from "./MyAddresses.vue?vue&type=style&index=0&id=75db0f52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75db0f52",
  null
  
)

export default component.exports